import { z } from 'zod';
/**
 * `?page=1&pageSize=50` (03-API-CONTRACT.md §0). Values arrive as query
 * strings, so both fields coerce from strings. `page` defaults to 1,
 * `pageSize` defaults to 50 and is capped at 200.
 */
export const PaginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=pagination.js.map